export default function(){
    return loadLitmosTile();
}

const loadLitmosTile = () => {
    return new Promise(resolve => {
        let $litmosContainer = $('.js-litmos-course-completion');
        if ($litmosContainer.length) {
            $litmosContainer.load('/Litmos/LitmosTile', {}, function () {
                resolve();
            });
        }else{
            resolve();
        }
    })
}